import s from './clients/state'
import * as a from './clients/actions'
import * as m from './clients/mutations'
import * as g from './clients/getters'

export const state = s
export const actions = {...a}
export const mutations = {...m}
export const getters = {...g}
